






















































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { InfoState } from '@/core/core.store';
import MswAppTitle from '@/shared/msw-app-title/msw-app-title.vue';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { PageTitleConfig } from '../../../shared/msw-app-title/type';

const cssPrefix = 'ipt-approve';

@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTextarea,
    SwButton,
    SwModal,
    SwModalBody,
    SwModalFooter,
  },
})

export default class MswITT extends SwExtendedVue {
  cssPrefix = cssPrefix;
  comments: string = '';
  showErr: boolean = false;
  showComment: boolean = false;
  invalidUrlMsg: string = '';
  showInvalidUrlMsg: boolean = false;
  disableActions: boolean = false;
  showConfirmationDailog: boolean = false;
  productDetails: any = {};
  showDetails: boolean = false;
  get getHeaderConfig(): PageTitleConfig {
    let title = '';
    if (this.$route.query.status === 'approve') {
      title = (this.$t('registerProduct.aproveHeader')
      .toString());
    } else if (this.$route.query.status === 'decline') {
      title = (this.$t('registerProduct.rejectHeader')
      .toString());
    } else if (this.$route.query.status === 'cancel') {
      title = (this.$t('registerProduct.cancelHeader')
      .toString());
    } else {
      title = (this.$t('registerProduct.iptHeader')
      .toString());
    }
    return {
      pageTitle: title,
      pageParentName: '',
      isShowDashboardIcon: false,
      isShowSlash: false,
    };
  }

  created() {
    this.checkForEmptyQuery();
  }

  checkForEmptyQuery() {
    if (this.$route.query.status === null || this.$route.query.status === undefined
    || this.$route.query.status === 'undefined' || this.$route.query.status === ''
    || this.$route.query.tempToken === null || this.$route.query.tempToken === ''
    || (this.$route.query.status !== 'cancel'
    && this.$route.query.status !== 'decline'
    && this.$route.query.status !== 'approve')) {
      this.invalidUrlMsg = (this.$t('registerProduct.invalidURLmsg')
      .toString());
      this.showInvalidUrlMsg = true;
    } else {
      if (this.$route.query.status === 'decline') this.showComment = true;
    }
  }

  approveWithAPIcall() {
    const req = {
      tempCode: this.$route.query.tempToken,
      mode: 'APPROVE',
    };
    this.$store.dispatch('MswProductsStoreModule/approveOrRejectITT', req)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.showConfirmationDailog = false;
        if (res.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
  }

  rejecttWithAPIcall() {
    if (this.comments === '') {
      this.showErr = true;
    } else {
      const req = {
        tempCode: this.$route.query.tempToken,
        mode: 'DECLINE',
        comments: this.comments,
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('MswProductsStoreModule/approveOrRejectITT', req)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.showConfirmationDailog = false;
        if (res.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
    }
  }

  cancelWithAPIcall() {
    const req = {
      tempCode: this.$route.query.tempToken,
      mode: 'CANCEL',
    };
    this.$store.commit('startLoading');
    this.$store.dispatch('MswProductsStoreModule/approveOrRejectITT', req)
    .then((res: any) => {
      this.$store.commit('stopLoading');
      this.showConfirmationDailog = false;
      if (res.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }
}
